import {type} from 'arktype'
import {klona} from 'klona'

export const Contact = type({
  email: type('string.email').configure({
    message: 'Please enter a valid email address',
  }),
})

export type Contact = typeof Contact.infer

const DEFAULT_CONTACT: Contact = {
  email: '',
}

export function getDefaultContact() {
  return klona(DEFAULT_CONTACT)
}
